import { Board } from "./Board";
import { CanvasManager } from "./CanvasManager";
import { GameVars } from "../../GameVars";
import { GameManager } from "../../GameManager";
import { GuiScene } from "../GUI/GuiScene";
import { AudioManager } from "../../AudioManager";

export class Cell {

    public colorID: number;
    public color: Phaser.Display.Color;
    public tileID: number;
    public ignoreTab: boolean = false;
    public tilePressed: boolean = false;
    public containMouse: boolean = false;
    public scene: Phaser.Scene;

    public backgroundImage: Phaser.GameObjects.Image;

    private board: Board;

    private grayScaleImage: Phaser.GameObjects.Graphics;
    private remarkedPoint: Phaser.GameObjects.Graphics;
    private colorImage: Phaser.GameObjects.Graphics;

    private switchColor: Phaser.Display.Color;
    private grayScaleColor: Phaser.Display.Color;
    private timePressed: number;
    private done: boolean;
    private painted: boolean = false;
    private autoPainted: boolean = false;
    private erased: boolean = false;

    constructor(scene: Phaser.Scene, board: Board, x: number, y: number, switchColor: Phaser.Display.Color, grayScaleColor: Phaser.Display.Color, tileID: number) {

        this.scene = scene;
        this.board = board;

        this.timePressed = 0;

        this.switchColor = switchColor;
        this.grayScaleColor = grayScaleColor;

        this.done = false;
        this.painted = false;
        this.tileID = tileID;
        this.colorID = 1;

        // Create Background Tile Image 
        let tileName = "Tile" + this.colorID + ".png";
        this.backgroundImage = new Phaser.GameObjects.Image(this.scene, x, y, "texture_atlas_1", tileName);
        this.backgroundImage.setInteractive();
        this.backgroundImage.setOrigin(0);

        // Create GS image 
        this.grayScaleImage = new Phaser.GameObjects.Graphics(scene);

        // Create the point that will appear in front of the cell in case of containing the current color
        this.remarkedPoint = new Phaser.GameObjects.Graphics(scene);
        this.remarkedPoint.visible = false;

        // Create the an image of the same size as the cell with it's color 
        this.colorImage = new Phaser.GameObjects.Graphics(scene);
        this.colorImage.visible = false;

        // Create callbacks for cells 
        this.backgroundImage.input.draggable = true;

    }

    public ignoreDestroy() {

        this.grayScaleImage.ignoreDestroy = true;
        this.remarkedPoint.ignoreDestroy = true;
        this.colorImage.ignoreDestroy = true;
        this.backgroundImage.ignoreDestroy = true;
    }

    public setNull() {

        this.done = false;
        this.painted = false;
        this.tileID = 0;
        this.switchColor = new Phaser.Display.Color(0, 0, 0);
        this.grayScaleColor = new Phaser.Display.Color(0, 0, 0);
        this.colorID = 0;

        this.backgroundImage.setTexture("Tile" + this.colorID + ".png");

        this.grayScaleImage.clear();
        this.remarkedPoint.clear();
        this.colorImage.clear();
    }

    public setData(x: number, y: number, board: Board, switchColor: Phaser.Display.Color, grayScalePixel: Phaser.Display.Color, useText: boolean, tileID: number, lightColour: boolean) {

        this.done = false;
        this.painted = false;
        this.tileID = tileID;
        this.switchColor = switchColor;
        this.grayScaleColor = grayScalePixel;

        if (CanvasManager.existColor(switchColor)) {

            this.colorID = CanvasManager.getColorID(switchColor);
            GameVars.colorCount[this.colorID - 1]++;

        } else {
            CanvasManager.addColor(switchColor);
            this.colorID = CanvasManager.getColorsAmmount();
        }

        this.backgroundImage.setTexture("Tile" + this.colorID + ".png");
        this.backgroundImage.setPosition(x, y);

        // Add the objects to the container
        CanvasManager.currentScene.board.add(this.backgroundImage);

        if (this.grayScaleColor === new Phaser.Display.Color(0, 0, 0, 0)) {
            console.log("ds");
        }

        this.grayScaleImage.fillStyle(this.grayScaleColor.color);
        this.grayScaleImage.fillRect(x, y, 32, 32);
        this.grayScaleImage.visible = true;
        CanvasManager.currentScene.board.add(this.grayScaleImage);

        this.remarkedPoint.fillStyle(this.switchColor.color, 0.7);
        this.remarkedPoint.lineStyle(1, 0x888888);
        this.remarkedPoint.fillRect(x + 10, y + 10, 12, 12);
        if (lightColour) { this.remarkedPoint.strokeRect(x + 10, y + 10, 12, 12); }
        this.remarkedPoint.visible = false;
        CanvasManager.currentScene.board.add(this.remarkedPoint);

        this.colorImage.fillStyle(this.switchColor.color);
        this.colorImage.fillRect(x, y, 32, 32);
        this.colorImage.visible = false;
        CanvasManager.currentScene.board.add(this.colorImage);
    }

    public onCellDown() {

        GuiScene.currentInstance.pencilTween.play(true);

        this.erased = false;

        this.tilePressed = true;
        this.containMouse = true;
        GameManager.ignorePainting = false;
    }

    public onCellUp() {

        if (CanvasManager.currentScene.camManager.isDragging) {
            return;
        }

        if (this.painted && this.color === GameVars.drawColors[GameVars.currentPixelColorID - 1] && CanvasManager.currentScene.camManager.dragToPaint) {
            return;
        }

        if (this.autoPainted && this.tilePressed && CanvasManager.currentScene.camManager.dragToPaint && !this.colorImage.visible) {
            this.autoPainted = false;
            this.tilePressed = false;
            this.colorImage.visible = false;
            return;
        }

        GameManager.captureMouseRelease();

        // To erase painted tile 
        if (this.done === false && this.painted === true && !CanvasManager.currentScene.camManager.dragToPaint) {
            if (this.color.color === this.getColorFromID(GameVars.currentPixelColorID).color) {

                this.erased = true;
                this.colorImage.visible = false;
                this.painted = false;
                this.timePressed = 0;
                AudioManager.playSound("pxl_erase");

                return;
            }
        }

        if (this.tilePressed === false) {
            GameManager.ignorePainting = true;
        }

        if (this.done) {
            return;
        }

        if (CanvasManager.currentScene.camManager.multiTouch) {
            return;
        }

        if (!CanvasManager.currentScene.camManager.hasDragged) {

            if (this.colorID === GameVars.currentPixelColorID) {

                // When the right tile is pressed 
                this.swapColor(true, true);

                if (CanvasManager.checkWin()) {

                    AudioManager.playSound("draw_done");
                    CanvasManager.currentScene.camManager.setMinZoom();

                    GameManager.deletePixelData(GameVars.currentDrawCategoryID, GameVars.currentDrawId);
                    GameManager.setDrawState(GameVars.currentDrawCategoryID, GameVars.currentDrawId, drawState.DRAW_FINISHED);

                    GameVars.recentDrawFinishedCategoryID = GameVars.currentDrawCategoryID;
                    GameVars.recentDrawFinishedID = GameVars.currentDrawId;

                    GameManager.writeGameData();
                }

            } else {

                // When the wrong tile is pressed 
                this.swapColor(false, true);
            }
        }

        this.tilePressed = false;
    }

    public cellReset() {

        this.timePressed = 0;

        this.done = false;
        this.painted = false;

        this.backgroundImage.visible = true;
        this.grayScaleImage.visible = true;
        this.remarkedPoint.visible = false;
        this.colorImage.visible = false;
    }

    public onCellMove() {

        if (this.done) {
            return;
        }

        if (this.painted && this.color === GameVars.drawColors[GameVars.currentPixelColorID - 1]) {
            return;
        }

        if (CanvasManager.currentScene.camManager.dragToPaint && CanvasManager.currentScene.camManager.isDragging === false) {

            if (this.colorID === GameVars.currentPixelColorID) {

                // When the right tile is pressed 
                this.swapColor(true, true);

                if (CanvasManager.checkWin()) {

                    AudioManager.playSound("draw_done");
                    CanvasManager.currentScene.camManager.setMinZoom();

                    GameManager.deletePixelData(GameVars.currentDrawCategoryID, GameVars.currentDrawId);
                    GameManager.setDrawState(GameVars.currentDrawCategoryID, GameVars.currentDrawId, drawState.DRAW_FINISHED);

                    GameVars.recentDrawFinishedCategoryID = GameVars.currentDrawCategoryID;
                    GameVars.recentDrawFinishedID = GameVars.currentDrawId;

                    GameManager.writeGameData();
                }

            } else {

                // When the wrong tile is pressed 
                this.swapColor(false, true);
            }

        }
    }

    public onCellOut() {

        if (this.containMouse) {
            this.containMouse = false;
            this.tilePressed = false;
        }

    }

    public isMouseInside(): boolean {

        if (this.scene.input.activePointer.worldX > this.backgroundImage.x &&
            this.scene.input.activePointer.worldX < this.backgroundImage.x + this.backgroundImage.width) {

            if (this.scene.input.activePointer.worldY > this.backgroundImage.y &&
                this.scene.input.activePointer.worldY < this.backgroundImage.y + this.backgroundImage.height) {

                return true;
            }
        }

        return false;
    }

    public getPositionX(): number {
        return this.backgroundImage.x;
    }

    public getPositionY(): number {
        return this.backgroundImage.y;
    }

    public update(delta: number) {

        // Update the opacity of the gray image
        let zoomNorm = CanvasManager.currentScene.camManager.getZoomNormalized();

        this.grayScaleImage.setAlpha(1 - zoomNorm);

        if (this.tilePressed) {
            this.timePressed += delta;
        }

        if (!(CanvasManager.currentScene.camManager.isPointer1Down() && CanvasManager.currentScene.camManager.isPointer2Down())) {

            if (this.timePressed >= CanvasManager.currentScene.camManager.dragTimerLimit) {

                if (!this.done && this.containMouse && !CanvasManager.currentScene.camManager.hasDragged && !GameManager.ignorePainting) {

                    if (GameVars.currentPixelColorID !== this.colorID && (this.painted && this.color === GameVars.drawColors[GameVars.currentPixelColorID - 1])) {
                        return;
                    }

                    if (GameVars.currentPixelColorID === this.colorID) {
                        this.swapColor(true, true);

                    } else if (!this.erased) {
                        this.swapColor(false, true);
                    }

                    this.autoPainted = true;
                }

                this.timePressed = 0;
            }
        }
    }

    public isDone(): boolean {
        return this.done;
    }

    public setRemarked(isMarked: boolean): void {

        if (this.done) {
            return;
        }

        if (isMarked) {
            this.remarkedPoint.visible = true;
            this.backgroundImage.setTexture("texture_atlas_1", "TileBase.png");
        } else {
            this.remarkedPoint.visible = false;
            this.backgroundImage.setTexture("texture_atlas_1", "Tile" + this.colorID + ".png");
        }

    }

    public swapColor(isOk: boolean, playSound: boolean = true) {

        let currColor = this.getColorFromID(GameVars.currentPixelColorID);

        this.colorImage.clear();
        this.colorImage.fillStyle(currColor.color);
        this.colorImage.fillRect(this.backgroundImage.x, this.backgroundImage.y, 32, 32);

        this.color = currColor;

        if (!isOk) {

            if (GameVars.currentPixelColorID === this.colorID && this.painted) {
                return;
            }

            this.colorImage.setAlpha(0.4);
            this.colorImage.visible = true;
            this.painted = true;

            if (playSound) {
                AudioManager.playSound("color_wrong");
            }

        } else {

            this.colorImage.setAlpha(1.0);
            this.colorImage.visible = true;

            this.grayScaleImage.visible = false;
            this.remarkedPoint.visible = false;

            CanvasManager.substractCell(this.colorID);
            CanvasManager.tilesDone++;

            this.done = true;

            if (playSound) {
                AudioManager.playSound("color_right");
            }

        }

        this.backgroundImage.setAlpha(this.switchColor.alpha);

        GuiScene.currentInstance.refreshEraseButtonValidity();
    }

    public cameraCulling() {

        let inside: boolean = false;
        if (this.backgroundImage.x > CanvasManager.currentScene.camManager.cam.x && this.backgroundImage.x < CanvasManager.currentScene.camManager.cam.x + CanvasManager.currentScene.camManager.cam.displayWidth) {
            if (this.backgroundImage.y > CanvasManager.currentScene.camManager.cam.y && this.backgroundImage.y < CanvasManager.currentScene.camManager.cam.y + CanvasManager.currentScene.camManager.cam.displayHeight) {

                // In this case the object is inside the camera
                this.backgroundImage.visible = true;
                inside = true;
            }
        }

        if (!inside) {
            this.backgroundImage.visible = false;
        }
    }

    private getColorFromID(findID: number): Phaser.Display.Color {
        return GameVars.drawColors[findID - 1];
    }


}

